(() => {
  const dialog = document.querySelector('[data-quick-dialog]');
  if (!dialog || !dialog.showModal) return;
  const content = dialog.querySelector('[data-quick-content]');
  const status = dialog.querySelector('[data-quick-status]');
  const fallback = dialog.querySelector('[data-quick-fallback]');
  const labels = JSON.parse(dialog.querySelector('[data-quick-labels]').textContent);
  let request, sequence = 0, adding = false, productUrl = '', toastTimer;
  async function load(url, optionIds, focusId) {
    request?.abort(); request = new AbortController();
    const current = ++sequence;
    status.textContent = labels.loading; fallback.hidden = true;
    content.setAttribute('aria-busy', 'true');
    content.querySelectorAll('button[type=submit],input[name=id]').forEach(el => el.disabled = true);
    try {
      const target = new URL(url, location.origin);
      target.searchParams.set('section_id', 'quick-product');
      if (optionIds) { target.searchParams.delete('variant'); target.searchParams.set('option_values', optionIds.join(',')); }
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id', preview);
      const response = await fetch(target, {signal:request.signal, credentials:'same-origin', headers:{Accept:'text/html'}});
      if (!response.ok) throw new Error(labels.load_error);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const panel = doc.querySelector('[data-quick-product]');
      if (!panel) throw new Error(labels.load_error);
      if (current !== sequence || !dialog.open) return;
      const previousQuantity = content.querySelector('[name=quantity]')?.value;
      content.replaceChildren(panel);
      const quantity = content.querySelector('[name=quantity]');
      if (previousQuantity && quantity) {
        const min = Number(quantity.min) || 1, step = Number(quantity.step) || 1;
        let value = min + Math.ceil(Math.max(0, Number(previousQuantity) - min) / step) * step;
        if (quantity.max) value = Math.min(value, Number(quantity.max));
        quantity.value = value;
      }
      status.textContent = '';
      if (focusId) content.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll:true});
    } catch (error) {
      if (error.name === 'AbortError' || current !== sequence) return;
      status.textContent = labels.load_error; fallback.href = productUrl; fallback.hidden = false;
    } finally { if (current === sequence) content.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('a[data-quick-mode]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (adding) return;
    event.preventDefault(); productUrl = trigger.href;
    dialog.dataset.mode = trigger.dataset.quickMode;
    dialog.querySelector('#QuickCartHeading').textContent = trigger.dataset.quickMode === 'view' ? labels.view : labels.add;
    content.replaceChildren(); status.textContent = labels.loading;
    dialog.showModal(); load(productUrl);
  });
  dialog.querySelector('[data-quick-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {request?.abort(); sequence++;});
  content.addEventListener('change', event => {
    if (!event.target.matches('[data-quick-option]') || adding) return;
    load(productUrl, [...content.querySelectorAll('[data-quick-option]')].map(select => select.value), event.target.id);
  });
  content.addEventListener('submit', async event => {
    if (!event.target.matches('[data-quick-form]')) return;
    event.preventDefault(); const form = event.target;
    const variant = form.querySelector('[name=id]'), button = form.querySelector('button[type=submit]');
    if (adding || variant.disabled || button.disabled || content.hasAttribute('aria-busy') || !form.reportValidity()) return;
    const data = new FormData(form); adding = true;
    button.disabled = true; button.textContent = labels.adding; status.textContent = '';
    form.querySelectorAll('select,input[type=number]').forEach(el => el.disabled = true);
    try {
      const response = await fetch(dialog.dataset.cartAddUrl, {method:'POST', body:data, credentials:'same-origin', headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : labels.add_error);
      status.textContent = labels.added;
      const toast = document.getElementById('CartStatus');
      if (toast) {clearTimeout(toastTimer);toast.textContent=labels.added;toast.hidden=false;toastTimer=setTimeout(()=>toast.hidden=true,5000);}
      try {
        const response = await fetch(dialog.dataset.cartJsonUrl, {credentials:'same-origin', headers:{Accept:'application/json'}});
        if (response.ok) {
          const cart = await response.json();
          document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
          document.querySelectorAll('.bag-link').forEach(el => el.setAttribute('aria-label', labels.cart_count.replace('[count]', cart.item_count)));
          document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
        }
      } catch {}
    } catch (error) {status.textContent = error.message || labels.add_error;}
    finally {adding=false;button.disabled=false;button.textContent=labels.add;form.querySelectorAll('select,input[type=number]').forEach(el=>el.disabled=false);}
  });
})();
